import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { VertAlert } from '@vertem-core/vertice-ds';
import { couponVariants } from 'Constants/Constants';

const CouponErrorSummary = ({ error='', type='info'  }) => {
  return (
    <motion.div
      className="cart-summary-coupon-alert"
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={couponVariants}
      transition={{ duration: 0.3 }}
    >
      <VertAlert message={error} type={type} closable={false} />
    </motion.div>
  );
};

CouponErrorSummary.propTypes = {
  error: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success'])
};

export default CouponErrorSummary;
